var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[(_vm.type === 'messagePhoto')?_c('message-photo-upload',{attrs:{"apiUrl":_vm.apiUrl}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }